module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/vhead6-da6bb98a74bb0c85118c22a1acfbe16d.jpg";